module.exports = __webpack_public_path__ + "static/media/euchorthippus_declivus_008_APA.4a6a325c.png";